import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';

export const { BuilderContentTypeError } = errorFactory('BuilderContentTypeError',{
    mapsToHTTPError: 'InvalidArgumentError'
  });

/** A generic error for when a Builder content type is invalid. */
export type BuilderContentTypeError = InstanceTypeOf<typeof BuilderContentTypeError>;
